/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetTestDto } from './GetTestDto';
import {
    GetTestDtoFromJSON,
    GetTestDtoFromJSONTyped,
    GetTestDtoToJSON,
} from './GetTestDto';
import type { GetExamDto } from './GetExamDto';
import {
    GetExamDtoFromJSON,
    GetExamDtoFromJSONTyped,
    GetExamDtoToJSON,
} from './GetExamDto';
import type { GetReactionDto } from './GetReactionDto';
import {
    GetReactionDtoFromJSON,
    GetReactionDtoFromJSONTyped,
    GetReactionDtoToJSON,
} from './GetReactionDto';

/**
 * 
 * @export
 * @interface GetResultDto
 */
export interface GetResultDto {
    /**
     * 
     * @type {string}
     * @memberof GetResultDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetResultDto
     */
    taskNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetResultDto
     */
    taskTime?: number | null;
    /**
     * 
     * @type {Array<GetReactionDto>}
     * @memberof GetResultDto
     */
    reactions?: Array<GetReactionDto> | null;
    /**
     * 
     * @type {GetExamDto}
     * @memberof GetResultDto
     */
    exam?: GetExamDto | null;
    /**
     * 
     * @type {GetTestDto}
     * @memberof GetResultDto
     */
    test?: GetTestDto | null;
    /**
     * 
     * @type {string}
     * @memberof GetResultDto
     */
    taskText?: string | null;
}

/**
 * Check if a given object implements the GetResultDto interface.
 */
export function instanceOfGetResultDto(value: object): value is GetResultDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetResultDtoFromJSON(json: any): GetResultDto {
    return GetResultDtoFromJSONTyped(json, false);
}

export function GetResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetResultDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'taskNumber': json['taskNumber'] == null ? undefined : json['taskNumber'],
        'taskTime': json['taskTime'] == null ? undefined : json['taskTime'],
        'reactions': json['reactions'] == null ? undefined : ((json['reactions'] as Array<any>).map(GetReactionDtoFromJSON)),
        'exam': json['exam'] == null ? undefined : GetExamDtoFromJSON(json['exam']),
        'test': json['test'] == null ? undefined : GetTestDtoFromJSON(json['test']),
        'taskText': json['taskText'] == null ? undefined : json['taskText'],
    };
}

export function GetResultDtoToJSON(value?: GetResultDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'taskNumber': value['taskNumber'],
        'taskTime': value['taskTime'],
        'reactions': value['reactions'] == null ? undefined : ((value['reactions'] as Array<any>).map(GetReactionDtoToJSON)),
        'exam': GetExamDtoToJSON(value['exam']),
        'test': GetTestDtoToJSON(value['test']),
        'taskText': value['taskText'],
    };
}

